import React from "react";

function Tab(props) {

    return (
        <div className="tab">
            <a href="">{props.tabName}</a>
        </div>
    )
}

export default Tab;